export default __webpack_public_path__ + "static/media/blm.7bb4eb98.JPG";